import React from "react";
import {
  ArrayField,
  Datagrid,
  ShowProps,
  TextField,
  UrlField,
  useRecordContext,
} from "react-admin";
import { Grid, Typography } from "@material-ui/core";
import SanitizedGrid from "components/SanitizedGrid";
import CustomDateField from "components/CustomDateField";
import StatusField from "../../components/StatusField";
import CustomBooleanField from "../../components/CustomBooleanField";
import CustomLabeled from "../../components/layout/CustomLabeled";

const Summary = (_props: ShowProps) => {
  const record = useRecordContext();

  return (
    <>
      <SanitizedGrid container spacing={2}>
        <Grid item xs={12}>
          <Typography variant="h6" gutterBottom>
            Subcontractor Detail
          </Typography>
        </Grid>

        <Grid item xs={6}>
          <CustomLabeled name="Subcontractor Identifier">
            <TextField source="subcontractorIdentifier" emptyText="-" />
          </CustomLabeled>
        </Grid>
        <Grid item xs={6}></Grid>
        <Grid item xs={3}>
          <CustomLabeled name="Company Acra / Nric">
            <TextField source="businessRegistrationNumber" emptyText="-" />
          </CustomLabeled>
        </Grid>
        <Grid item xs={3}>
          <CustomLabeled name="Id">
            <TextField source="id" emptyText="-" />
          </CustomLabeled>
        </Grid>
        <Grid item xs={6}></Grid>

        <Grid item xs={3}>
          <CustomLabeled name="Name">
            <TextField source="name" emptyText="-" />
          </CustomLabeled>
        </Grid>
        <Grid item xs={3}>
          <CustomLabeled name="Person-in-charge">
            <TextField source="personInCharge" emptyText="-" />
          </CustomLabeled>
        </Grid>
        <Grid item xs={6}></Grid>

        <Grid item xs={3}>
          <CustomLabeled name="Include Goods and Services Tax">
            <CustomBooleanField
              source="isGst"
              textForTrueValue="Yes"
              textForFalseValue="No"
            />
          </CustomLabeled>
        </Grid>
        <Grid item xs={3}>
          <CustomLabeled name="Status">
            <StatusField source="status" />
          </CustomLabeled>
        </Grid>
        <Grid item xs={6}></Grid>

        {record.isGst && (
          <>
            <Grid item xs={3}>
              <CustomLabeled name="Gst Number">
                <TextField source="gstNumber" emptyText="-" />
              </CustomLabeled>
            </Grid>
            <Grid item xs={9}></Grid>
          </>
        )}

        <Grid item xs={3}>
          <CustomLabeled name="Mbc Vendor Id">
            <TextField source="mbcVendorId" emptyText="-" />
          </CustomLabeled>
        </Grid>
        <Grid item xs={3}>
          <CustomLabeled name="Prefix Code">
            <TextField source="prefixCode" emptyText="-" />
          </CustomLabeled>
        </Grid>
        <Grid item xs={6}></Grid>

        <Grid item xs={3}>
          <CustomLabeled name="Bank Account Number">
            <TextField source="bankAccountNumber" emptyText="-" />
          </CustomLabeled>
        </Grid>
        <Grid item xs={9}></Grid>

        <Grid item xs={12}>
          <Typography variant="h6" gutterBottom>
            Contact Detail
          </Typography>
        </Grid>

        <Grid item xs={3}>
          <CustomLabeled name="Contact">
            <TextField source="contactNumber" emptyText="-" />
          </CustomLabeled>
        </Grid>
        <Grid item xs={3}>
          <CustomLabeled name="Email">
            <TextField source="email" emptyText="-" />
          </CustomLabeled>
        </Grid>
        <Grid item xs={3}></Grid>

        <Grid item xs={6}>
          <CustomLabeled name="Address">
            <TextField source="address" emptyText="-" />
          </CustomLabeled>
        </Grid>
        <Grid item xs={6}></Grid>

        <Grid item xs={3}>
          <CustomLabeled name="Unit No.">
            <TextField source="unitNumber" emptyText="-" />
          </CustomLabeled>
        </Grid>
        <Grid item xs={3}>
          <CustomLabeled name="Postal Code">
            <TextField source="postalCode" emptyText="-" />
          </CustomLabeled>
        </Grid>
        <Grid item xs={6}></Grid>

        <Grid item xs={12}>
          <Typography variant="h6" gutterBottom>
            Poc Numbers
          </Typography>
        </Grid>

        <Grid item xs={4}>
          <ArrayField source="pocNumbers" fieldKey="id">
            <Datagrid
              empty={<Typography variant="body2">No Result found</Typography>}
            >
              <TextField source="pocNumber" emptyText="-" />
            </Datagrid>
          </ArrayField>
        </Grid>
        <Grid item xs={8}></Grid>

        <Grid item xs={12}>
          <Typography variant="h6" gutterBottom>
            Document Details
          </Typography>
        </Grid>

        <Grid item xs={6}>
          <ArrayField source="documents" fieldKey="id">
            <Datagrid
              empty={<Typography variant="body2">No Result found</Typography>}
            >
              <TextField source="type" emptyText="-" />
              <TextField source="serialNumber" emptyText="-" />
              <CustomDateField source="expiryDate" emptyText="-" />
              <UrlField source="fileUrl" emptyText="-" />
            </Datagrid>
          </ArrayField>
        </Grid>
        <Grid item xs={6}></Grid>
      </SanitizedGrid>
    </>
  );
};

export default Summary;
